"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoAuthProvider = void 0;
var jwt = require("jsonwebtoken");
var info_credentials_1 = require("../auth/info.credentials");
var constants_1 = require("../constants");
var api_1 = require("../info-auth-api/api");
var auth_error_1 = require("../model/auth.error");
var auth_user_1 = require("../model/auth.user");
var user_info_1 = require("../model/user.info");
var storage_1 = require("../storage");
var uuid = require('uuid/v4');
var constants_2 = require("../constants");
var createAuthUserFromToken = function (idToken) {
    var jwtdata = jwt.verify(idToken, constants_2.SECRET_KEY);
    var objToMap = new Map(Object.entries(jwtdata));
    var userInfo = {
        preferred_username: objToMap.get('email'),
        email: objToMap.get('email'),
        profile: objToMap.get('profile'),
        phone_number: objToMap.get('phone_number'),
        name: objToMap.get('name'),
        family_name: objToMap.get('family_name'),
        given_name: objToMap.get('given_name'),
        customAttributes: {}
    };
    var user = new auth_user_1.default(objToMap.get('name'), new user_info_1.UserInfo(objToMap.get('sub'), objToMap.get('sub'), userInfo));
    return user;
};
var createCredentialData = function (userDetails, locale) {
    var data = {
        id: userDetails.id_token,
        access: userDetails.access_token,
        refresh: userDetails.refresh_token,
        language: locale
    };
    return data;
};
var parseUserAuthSignUpParams = function (params, config) {
    // Attrib mapping configuration
    var userAuthAttributesMap = config.provider.infoauth.userAttributeMap;
    // Filtering params for USER_AUTH table columns
    var userAuthParams = { userName: params[userAuthAttributesMap.preferred_username] };
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (userAuthAttributesMap.hasOwnProperty(key) && key !== 'preferred_username') {
            userAuthParams[userAuthAttributesMap[key]] = value;
        }
    }
    return userAuthParams;
};
var parseUserProfileSignUpParams = function (params, res, config) {
    // Attrib mapping configuration
    var userProfileAttributesMap = config.provider.infoauth.userProfileAttributeMap;
    //Todo: Need to see if we can read provider directly here
    var userData = {};
    try {
        //For infoauth provider
        userData = JSON.parse(res.sub);
    }
    catch (e) {
        //For AWS provider
        userData.aeUserAuthUuid = res.sub;
    }
    var userProfileParams = { aeUserProfileUuid: userData.aeUserAuthUuid, aeTransactionId: userData.aeTransactionId ? userData.aeTransactionId : uuid() };
    // Filtering params for USER_PROFILE table columns
    for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (userProfileAttributesMap.hasOwnProperty(key)) {
            userProfileParams[userProfileAttributesMap[key]] = value;
        }
    }
    // Adding extension properties to params
    /* const key: string = 'extensionProperties';
    const extensionProperties: any = {};
    if(userProfileAttributesMap.hasOwnProperty(key)){
        const fields: string[] = String(userProfileAttributesMap[key]).split(',');
        fields.forEach((field: string) => {
            extensionProperties[field.trim()] = params[field.trim()];
        })
        userProfileParams['extensionProperties'] = extensionProperties;
    } */
    return userProfileParams;
};
var InfoAuthProvider = /** @class */ (function () {
    function InfoAuthProvider(config) {
        this.config = config;
        var storage = storage_1.createStorage(config);
        this.credentials = new info_credentials_1.Credentials(storage, config);
    }
    /**
     * Log In
     * @param username
     * @param password
     */
    InfoAuthProvider.prototype.signIn = function (userName, password, locale) {
        return __awaiter(this, void 0, void 0, function () {
            var userMap, userDetails, e_1, apiError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userMap = {
                            userName: userName,
                            password: password
                        };
                        return [4 /*yield*/, api_1.default.signIn(this.config.provider.infoauth.redirectUri, userMap)];
                    case 1:
                        userDetails = _a.sent();
                        this.credentials.setCredential(createCredentialData(userDetails, locale));
                        return [2 /*return*/, createAuthUserFromToken(userDetails.id_token)];
                    case 2:
                        e_1 = _a.sent();
                        apiError = e_1.errorResponse.errors && e_1.errorResponse.errors.length
                            ? e_1.errorResponse.errors[0]
                            : undefined;
                        if (!apiError) {
                            throw e_1;
                        }
                        switch (apiError.reason) {
                            case constants_1.ErrorCodeEnum.INVALID_CREDENTIAL:
                                throw new auth_error_1.default(apiError.message, constants_1.ErrorCodeEnum.INVALID_CREDENTIAL);
                            case constants_1.ErrorCodeEnum.PENDING_VERIFICATION:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.PENDING_VERIFICATION, constants_1.ErrorCodeEnum.PENDING_VERIFICATION, apiError.extendedHelp);
                            case constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.PENDING_VERIFICATION, constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD);
                            case constants_1.ErrorCodeEnum.MISSING_PARAMETER:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.MISSING_PARAMETER, constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD);
                            case constants_1.ErrorCodeEnum.LOCKED:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.LOCKED, constants_1.ErrorCodeEnum.LOCKED);
                            case constants_1.ErrorCodeEnum.DEACTIVATED:
                                throw new auth_error_1.default(constants_1.AuthMessageEnum.DEACTIVATED, constants_1.ErrorCodeEnum.DEACTIVATED);
                            default:
                                throw new auth_error_1.default(e_1.message, constants_1.ErrorCodeEnum.SYSTEM_ERROR);
                        }
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign up with username, password and other attrbutes like phone, email
     * @param params
     */
    InfoAuthProvider.prototype.signUp = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var userAuthSignupParam, userDetails, res, e_2, apiError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userAuthSignupParam = parseUserAuthSignUpParams(params, this.config);
                        return [4 /*yield*/, api_1.default.signUp(this.config.provider.infoauth.redirectUri, userAuthSignupParam)];
                    case 1:
                        userDetails = _a.sent();
                        res = {
                            sub: JSON.stringify(userDetails),
                            preferred_username: userDetails.userName,
                            isUserConfirmed: false
                        };
                        return [2 /*return*/, res];
                    case 2:
                        e_2 = _a.sent();
                        apiError = e_2.errorResponse.errors && e_2.errorResponse.errors.length
                            ? e_2.errorResponse.errors[0]
                            : undefined;
                        if (!apiError) {
                            throw e_2;
                        }
                        switch (apiError.reason) {
                            case constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT:
                                throw new auth_error_1.default(apiError.message, constants_1.ErrorCodeEnum.INVALID_EMAIL_FORMAT);
                            case constants_1.ErrorCodeEnum.WEAK_PASSWORD:
                                throw new auth_error_1.default(apiError.message, constants_1.ErrorCodeEnum.WEAK_PASSWORD);
                            default:
                                throw new auth_error_1.default(e_2.message, constants_1.ErrorCodeEnum.SYSTEM_ERROR);
                        }
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    InfoAuthProvider.prototype.signUpUserProfile = function (params, res) {
        return __awaiter(this, void 0, void 0, function () {
            var userProfileSignupParam, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userProfileSignupParam = parseUserProfileSignUpParams(params, res, this.config);
                        return [4 /*yield*/, api_1.default.signUpUserProfile(this.config.provider.infoauth.redirectUri, userProfileSignupParam)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_3 = _a.sent();
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Send the verfication code to confirm sign up
     * @param username
     * @param code
     */
    InfoAuthProvider.prototype.confirmSignUp = function (userName, code, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            var userMap, userDetails, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userMap = {
                            userName: userName,
                            code: code,
                            transactionId: transactionId
                        };
                        return [4 /*yield*/, api_1.default.confirmSignUp(this.config.provider.infoauth.redirectUri, userMap)];
                    case 1:
                        userDetails = _a.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 2:
                        e_4 = _a.sent();
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Insert usermapping for user with default role
     * @param username
     */
    InfoAuthProvider.prototype.insertDefaultUserMapping = function (userId, transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            var userMapping, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api_1.default.insertDefaultUserMapping(this.config.provider.infoauth.redirectUri, userId, transactionId)];
                    case 1:
                        userMapping = _a.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 2:
                        e_5 = _a.sent();
                        throw e_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Request to resend the verification code
     * @param username
     */
    InfoAuthProvider.prototype.resendSignUp = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            var userMap, userDetails, delivery, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userMap = {
                            "userName": username
                        };
                        return [4 /*yield*/, api_1.default.resendVerificationCode(this.config.provider.infoauth.redirectUri, userMap)];
                    case 1:
                        userDetails = _a.sent();
                        delivery = {
                            attributeName: userDetails.codeDeliveries[0].attributeName,
                            deliveryMedium: userDetails.codeDeliveries[0].deliveryMedium,
                            destination: userDetails.codeDeliveries[0].destination
                        };
                        return [2 /*return*/, delivery];
                    case 2:
                        e_6 = _a.sent();
                        throw e_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * logout
     */
    InfoAuthProvider.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.credentials.removeCredential();
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    /**
     * Change password by authenticated user
     * @param user
     * @param oldPassword
     * @param newPassword
     */
    InfoAuthProvider.prototype.changePassword = function (userName, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var userMap, userDetails, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userMap = {
                            userName: userName,
                            oldPassword: oldPassword,
                            newPassword: newPassword
                        };
                        return [4 /*yield*/, api_1.default.changePassword(this.config.provider.infoauth.redirectUri, userMap)];
                    case 1:
                        userDetails = _a.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 2:
                        e_7 = _a.sent();
                        throw e_7;
                    case 3: return [2 /*return*/, 'SUCCESS'];
                }
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param username
     */
    InfoAuthProvider.prototype.forgotPassword = function (userName) {
        return __awaiter(this, void 0, void 0, function () {
            var userMap, result, delivery, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userMap = {
                            userName: userName
                        };
                        return [4 /*yield*/, api_1.default.forgotPassword(this.config.provider.infoauth.redirectUri, userMap)];
                    case 1:
                        result = _a.sent();
                        delivery = {
                            attributeName: result.codeDeliveries[0].attributeName,
                            deliveryMedium: result.codeDeliveries[0].deliveryMedium,
                            destination: result.codeDeliveries[0].destination
                        };
                        return [2 /*return*/, delivery];
                    case 2:
                        e_8 = _a.sent();
                        throw e_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param username
     * @param code
     * @param password
     */
    InfoAuthProvider.prototype.forgotPasswordSubmit = function (userName, code, password) {
        return __awaiter(this, void 0, void 0, function () {
            var userMap, result, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        userMap = {
                            userName: userName,
                            code: code,
                            password: password
                        };
                        return [4 /*yield*/, api_1.default.passwordReset(this.config.provider.infoauth.redirectUri, userMap)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, 'SUCCESS'];
                    case 2:
                        e_9 = _a.sent();
                        throw e_9;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get current authenticated user
     * @param params
     */
    InfoAuthProvider.prototype.currentAuthenticatedUser = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var userSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.currentSession()];
                    case 1:
                        userSession = _a.sent();
                        if (userSession.idToken) {
                            return [2 /*return*/, createAuthUserFromToken(userSession.idToken.token)];
                        }
                        else {
                            throw new auth_error_1.default(constants_1.AuthMessageEnum.USER_NOT_LOGGEDIN, constants_1.ErrorCodeEnum.USER_NOT_LOGGEDIN);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get current user's session
     */
    InfoAuthProvider.prototype.currentSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userSession;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.credentials.getSession()];
                    case 1:
                        userSession = _a.sent();
                        if (userSession && userSession.isValid()) {
                            return [2 /*return*/, userSession];
                        }
                        else {
                            throw new auth_error_1.default(constants_1.AuthMessageEnum.USER_NOT_LOGGEDIN, constants_1.ErrorCodeEnum.USER_NOT_LOGGEDIN);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param user Update user attributes
     * @param attributes
     */
    InfoAuthProvider.prototype.updateUserAttributes = function (user, attributes) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, 'SUCCESS'];
            });
        });
    };
    return InfoAuthProvider;
}());
exports.InfoAuthProvider = InfoAuthProvider;
var infoAuthProvider;
var createInfoAuthProvider = function (config) {
    if (infoAuthProvider === undefined) {
        configureInfoAuth(config);
        infoAuthProvider = new InfoAuthProvider(config);
        Object.freeze(infoAuthProvider);
    }
    return infoAuthProvider;
};
var configureInfoAuth = function (config) { };
exports.default = createInfoAuthProvider;
//# sourceMappingURL=info.auth.provider.js.map